import { render, staticRenderFns } from "./MainPagination.vue?vue&type=template&id=95d097ac&scoped=true"
import script from "./MainPagination.vue?vue&type=script&lang=js"
export * from "./MainPagination.vue?vue&type=script&lang=js"
import style0 from "./MainPagination.vue?vue&type=style&index=0&id=95d097ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d097ac",
  null
  
)

export default component.exports